












































































































































































































































































import Vue from "vue";

import store, {PartnerPayDateStore} from "../services/PartnerPayDateStore"
import PayMode, { PayModeDefaultProps } from "../models/PayMode";
import PayCountType, { PayCountTypeDefaultProps } from "../models/PayCountType";
import PayDayType, { PayDayTypeDefaultProps } from "../models/PayDayType";
import Ledger, { LedgerDefaultProps } from "../models/Ledger";
import { PartnerPayDateDefaultProps } from "../models/PartnerPayDate";

import { ValidationRules } from "@/models/Validation";
import { PartnerPayDateValidationRules as rules } from "../models/PartnerPayDate";
import DateInput from "@/components/DateInput.vue";
  
interface Data {
    store: PartnerPayDateStore;
    payDateId: number;
    payMode: PayMode;
    payCountType: PayCountType;
    payDayType: PayDayType;
    customerAccCode: Ledger;
    supplierAccCode: Ledger;
    rules: ValidationRules;
}

interface Computed {
    tax: number;
}

export default Vue.extend<Data, {}, Computed, {}>({
    components: {
        DateInput
    },

    data() {
        return {
            store,
            payDateId: 0,
            payMode: {...PayModeDefaultProps},
            payCountType: {...PayCountTypeDefaultProps},
            payDayType: {...PayDayTypeDefaultProps},
            customerAccCode: {...LedgerDefaultProps},
            supplierAccCode: {...LedgerDefaultProps},
            rules
        };
    },
  
    async beforeMount() {
        this.payDateId = Number(this.$route.params["payDateId"]) || 0;
        
        await Promise.all([
            this.store.loadPayModes(),
            this.store.loadPayCountTypes(),
            this.store.loadPayDayTypes(),
            this.store.loadLedgers()
        ]);
        
        if (this.payDateId > 0) {
            await this.store.loadPartnerPayDate(this.payDateId);
        } else {
            this.store.partnerPayDate = {...PartnerPayDateDefaultProps};
        }
        
        this.payMode = this.store.payModes.find(x => x.id == this.store.partnerPayDate.paymentMode) ?? {...PayModeDefaultProps}
        this.payCountType = this.store.payCountTypes.find(x => x.id == this.store.partnerPayDate.countType) ?? {...PayCountTypeDefaultProps}
        this.payDayType = this.store.payDayTypes.find(x => x.id == this.store.partnerPayDate.dayType) ?? {...PayDayTypeDefaultProps}
        this.customerAccCode = this.store.ledgers.find(x => x.accNo == this.store.partnerPayDate.customerAccCode) ?? {...LedgerDefaultProps}
        this.supplierAccCode = this.store.ledgers.find(x => x.accNo == this.store.partnerPayDate.supplierAccCode) ?? {...LedgerDefaultProps}
    },

    watch: {
        payMode() {
            this.store.partnerPayDate.paymentMode = this.payMode?.id ?? 1;
        },
        payCountType() {
            this.store.partnerPayDate.countType = this.payCountType?.id ?? 1;
        },
        payDayType() {
            this.store.partnerPayDate.dayType = this.payDayType?.id ?? 1;
        },
        customerAccCode() {
            this.store.partnerPayDate.customerAccCode = this.customerAccCode?.accNo ?? "";
        },
        supplierAccCode() {
            this.store.partnerPayDate.supplierAccCode = this.supplierAccCode?.accNo ?? "";
        }
    }
});
